import { FC, ReactNode } from 'react';
import { FormikProps } from 'formik';
import classNames from 'classnames';
import { Allergen, DietType } from 'lib/home/generated/types/api';
import { SelectionButton } from 'lib/components';
import { PreferencesFormValues } from './PreferencesForm';
import { mealPreferencesIconMap } from './PreferencesForm.helpers';

export interface PreferencesFormSectionProps {
  formikProps?: FormikProps<PreferencesFormValues>;
  name: string;
  options: { label: string; value: DietType | Allergen }[];
  type: 'checkbox' | 'radio';
  title: ReactNode;
  className?: string;
}

export const PreferencesFormSection: FC<PreferencesFormSectionProps> = ({
  title,
  formikProps,
  name,
  options,
  type,
  className
}) => (
  <section className={classNames('preferences-form--section my-10', className)}>
    {title && <h3 className="h5 !font-normal normal-case">{title}</h3>}

    <div className="flex flex-wrap -m-2 md:m-0 md:gap-4">
      {options.map(({ label, value }) => {
        const optionTypeProps = {
          radio: {
            name,
            value,
            checked: formikProps?.values[name] === value
          },
          checkbox: {
            name: `${name}.${value}`
          }
        };

        return (
          <div key={`option-${value}`} className="flex-0 w-1/2 basis-1/2  md:w-auto md:basis-auto p-2 md:p-0">
            <SelectionButton
              type={type}
              icon={mealPreferencesIconMap[value]}
              label={label}
              {...optionTypeProps[type]}
            />
          </div>
        );
      })}
    </div>
  </section>
);
